import Modal from "../Modal/Modal";
import PropTypes from "prop-types";
import useEventListener from "../../hooks/useEventListener";

function Place({
    name,
    order,
    content,
    modalVisible,
    onSetModalVisible,
    handleHotspotAssigning,
    hotspotHighlight,
    isDesktop
}) {
    let { description, image, url, hotspot } = content;

    function handleCLick() {
        handleHotspotAssigning(order, "map");
        onSetModalVisible(order);
    }

    function handleOutsideClick(event) {
        if (!hotspotHighlight?.order) return;

        let targetElement = event.target;
        const activeHotspot = document.querySelector(".buttonIsActive");
        do {
            if (targetElement === activeHotspot) return;

            targetElement = targetElement.parentNode;
        } while (targetElement);
        handleHotspotAssigning(null);
    }

    useEventListener("click", handleOutsideClick);

    return (
        <>
            <div
                className={`buttonWrapper ${
                    hotspotHighlight?.order === order && isDesktop ? "buttonIsActive" : ""
                }`}
                style={{
                    "--topDesktop": `${hotspot.desktop.y}%`,
                    "--leftDesktop": `${hotspot.desktop.x}%`,
                    "--topMobile": `${hotspot.mobile.y}px`,
                    "--leftMobile": `${hotspot.mobile.x}px`
                }}
            >
                <button
                    className="dotWrapper"
                    onClick={() => handleCLick()}
                    onMouseEnter={() => hotspotHighlight && hotspotHighlight.order !== order ? handleHotspotAssigning(null) : null}
                    onFocus={() => hotspotHighlight && hotspotHighlight.order !== order ? handleHotspotAssigning(order, "map") : null}
                    data-number={order}
                    aria-label={`${order}: ${name}`}
                >
                    <span className="outer toBottom">
                        <span className="inner">
                            <span>{name}</span>
                        </span>
                    </span>
                </button>
            </div>

            {modalVisible === order && (
                <Modal
                    name={name}
                    description={description}
                    onSetModalVisible={onSetModalVisible}
                    image={image}
                    url={url}
                    order={order}
                    isDesktop={isDesktop}
                    hotspotHighlightOrigin={hotspotHighlight.origin}
                />
            )}
        </>
    );
}

Place.propTypes = {
    name: PropTypes.string.isRequired,
    order: PropTypes.string.isRequired,
    content: PropTypes.object.isRequired,
    modalVisible: PropTypes.string,
    onSetModalVisible: PropTypes.func.isRequired,
    hotspotHighlight: PropTypes.object,
    handleHotspotAssigning: PropTypes.func.isRequired,
    isDesktop: PropTypes.bool.isRequired
};

export default Place;
